// Desktop mega menu: each parent category's child list is collapsed by default
// and revealed on click (accordion). The opened parent is underlined via the
// aria-expanded attribute (see _header-menu.liquid styles).
//
// The header menu component measures the panel height when it first opens and
// reveals content through a clip-path bounded by --full-open-header-height.
// Expanding/collapsing children changes the content height after that initial
// measurement, so we recompute the relevant CSS variables on each toggle to
// keep the content from being clipped.

const DESKTOP_QUERY = '(min-width: 990px)';

if (!window.__megaMenuAccordionBound) {
  window.__megaMenuAccordionBound = true;
  document.addEventListener('click', onMegaMenuClick);
}

/**
 * @param {MouseEvent} event
 */
function onMegaMenuClick(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  if (!window.matchMedia(DESKTOP_QUERY).matches) return;

  const parentLink = target.closest('.mega-menu__link--parent');
  if (!parentLink) return;

  // Only intercept parents that actually have a child list to reveal.
  const childList = parentLink.parentElement?.querySelector('ul');
  if (!childList) return;

  event.preventDefault();

  const willOpen = parentLink.getAttribute('aria-expanded') !== 'true';

  // Accordion: collapse other open parents within the same column group.
  const list = parentLink.closest('.mega-menu__list');
  list?.querySelectorAll('.mega-menu__link--parent[aria-expanded="true"]').forEach((other) => {
    if (other !== parentLink) other.setAttribute('aria-expanded', 'false');
  });

  parentLink.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

  refreshSubmenuHeight(parentLink);
}

/**
 * Recompute the header menu panel height so the (now taller/shorter) content is
 * fully revealed by the clip-path animation.
 * @param {Element} parentLink
 */
function refreshSubmenuHeight(parentLink) {
  const submenu = parentLink.closest('.menu-list__submenu');
  const headerComponent = parentLink.closest('header-component');
  if (!(submenu instanceof HTMLElement) || !(headerComponent instanceof HTMLElement)) return;

  requestAnimationFrame(() => {
    const submenuHeight = submenu.offsetHeight;
    headerComponent.style.setProperty('--submenu-height', `${submenuHeight}px`);

    const overlap = headerComponent.hasAttribute('data-submenu-overlap-bottom-row');
    const topRow = headerComponent.querySelector('.header__row--top');
    const headerVisible =
      overlap && topRow instanceof HTMLElement ? topRow.offsetHeight : headerComponent.offsetHeight;

    headerComponent.style.setProperty(
      '--full-open-header-height',
      submenuHeight ? `${submenuHeight + headerVisible}px` : '0px'
    );
  });
}
